export const NODE_BASE_URL = process.env.REACT_APP_NODE_BASE_URL

export const getAxiosOptions = (user) => {
  let axiosOptions = {}
  if (user) {
    axiosOptions = {
      headers: { Authorization: `Bearer ${user.token}` },
    }
  }
  return axiosOptions
}
